import { render, staticRenderFns } from "./ReviewsAndRatingsV2.vue?vue&type=template&id=59ce7d3c"
import script from "./ReviewsAndRatingsV2.vue?vue&type=script&lang=js"
export * from "./ReviewsAndRatingsV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports